package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill

enum class StatisticFlagType(
    val value:String
)
{
    TOTAL_AMOUNT(
        value = "TotalAmount"
    ),
    TOTAL_IN_CHF(
        value = "TotalInCHF"
    ),
    ZERO(
        value = "zero"
    )
}